import NavButton from '@atoms/NavButton/NavButton';
import HorizontalDirectionEnum from '@models/enums/HorizontalDirectionEnum';
import useMediaQuery from '@utils/hooks/useMediaQuery';
import classNames from 'classnames';

interface Props {
  readonly arrowIconSize?: string;
  readonly carouselNavId: string;
  readonly componentName: string;
  readonly counterText: string;
  readonly dataTestId?: string;
  readonly isCounterTextBetweenArrows?: boolean;
  readonly hasWrapper?: boolean;
  readonly productName?: string;
}

const PaginationArrows = ({
  arrowIconSize = '1.05rem',
  carouselNavId,
  componentName,
  counterText,
  dataTestId = 'Pagination-Arrows',
  isCounterTextBetweenArrows = false,
  hasWrapper = true,
  productName = '',
}: Props) => {
  const isMobile = useMediaQuery(1024);

  return (
    <div
      className={classNames({
        'flex rounded-[40px] bg-grey-600 py-2.5 pl-5 pr-[15px]': hasWrapper,
      })}
      data-testid={dataTestId}
    >
      <div className="flex h-full items-center justify-center gap-2.5">
        {!isCounterTextBetweenArrows && (
          <p
            className={classNames(
              'pr-2.5 text-grey-200',
              isMobile ? 'body-four' : 'body-three'
            )}
          >
            {counterText}
          </p>
        )}

        <NavButton
          direction={HorizontalDirectionEnum.Left}
          id={carouselNavId}
          sizeClassName="h-[18px] w-[18px] lg:w-[28px] lg:h-[28px]"
          iconSize={arrowIconSize}
          additionalDataLayerProperties={{
            product_id: productName,
            component_name: componentName,
          }}
        />

        {isCounterTextBetweenArrows && (
          <p className="body-three hidden text-yellow lg:block">
            {counterText}
          </p>
        )}

        <NavButton
          direction={HorizontalDirectionEnum.Right}
          id={carouselNavId}
          sizeClassName="h-[18px] w-[18px] lg:w-[28px] lg:h-[28px]"
          iconSize={arrowIconSize}
          additionalDataLayerProperties={{
            product_id: productName,
            component_name: componentName,
          }}
        />
      </div>
    </div>
  );
};

export default PaginationArrows;
